import { createAction } from '@reduxjs/toolkit';

import { getFailurePayloadCreator, getPayloadCreator, type Meta } from '../core/actionHelpers';
import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';
import type {
  CreateEntitlementRequest,
  CreateEntitlementResponse,
  Entitlement,
  EntitlementProps,
} from './entitlementsTypes';

type EntitlementsMeta<Result = unknown> = Meta<EntitlementProps, Result>;

const failurePayloadCreator = getFailurePayloadCreator<unknown, EntitlementsMeta>();

export const getEntitlements = createAction(
  'GET_ENTITLEMENTS',
  getPayloadCreator<void, EntitlementProps, EntitlementsMeta<Entitlement[]>>(),
);
export const getEntitlementsSuccess = createAction(
  'GET_ENTITLEMENTS_SUCCESS',
  getPayloadCreator<QcsSyncResourcesPayload<EntitlementProps>>(),
);
export const getEntitlementsFailure = createAction('GET_ENTITLEMENTS_FAILURE', failurePayloadCreator);

export const createEntitlement = createAction(
  'CREATE_ENTITLEMENT',
  getPayloadCreator<CreateEntitlementRequest, EntitlementProps, EntitlementsMeta<CreateEntitlementResponse>>(),
);
export const createEntitlementSuccess = createAction(
  'CREATE_ENTITLEMENT_SUCCESS',
  getPayloadCreator<Entitlement[] | QcsSyncResourcesPayload<EntitlementProps>>(),
);
export const createEntitlementFailure = createAction('CREATE_ENTITLEMENT_FAILURE', failurePayloadCreator);
